import {
  FETCH_FEED_START,
  FETCH_FEED_FULFILLED,
  FETCH_FEED_REJECTED,
  FETCH_PINNED_FEED_START,
  FETCH_PINNED_FEED_FULFILLED,
  FETCH_PINNED_FEED_REJECTED,
  FETCH_FEED_POST_START,
  FETCH_FEED_POST_FULFILLED,
  FETCH_FEED_POST_REJECTED,
  FETCH_MORE_FEED_FULFILLED,
  FETCH_MORE_FEED_REJECTED,
  FETCH_MORE_FEED_START,
  FETCH_FEED_COUNT_START,
  FETCH_FEED_COUNT_FULFILLED,
  FETCH_FEED_COUNT_REJECTED,
  UPLOAD_MEDIA_START,
  UPLOAD_MEDIA_FULFILLED,
  UPLOAD_MEDIA_REJECTED,
  UPLOAD_MEDIA_URL_START,
  UPLOAD_MEDIA_URL_FULFILLED,
  UPLOAD_MEDIA_URL_REJECTED,
  FETCH_EXERCISES_START,
  FETCH_EXERCISES_FULFILLED,
  FETCH_EXERCISES_REJECTED,
  FETCH_TOP_PR_START,
  FETCH_TOP_PR_FULFILLED,
  FETCH_TOP_PR_REJECTED,
  EDIT_TOP_PR_START,
  EDIT_TOP_PR_FULFILLED,
  EDIT_TOP_PR_REJECTED,
  SUBMIT_SUPPORT_START,
  SUBMIT_SUPPORT_FULFILLED,
  SUBMIT_SUPPORT_REJECTED,
} from './actionTypes';

const initialState = {
  isFeedLoading: true,
  isPinnedFeedLoading: true,
  isNextPageLoading: false,
  isMediaLoading: false,
  isLoadingExercises: false,
  isPrCountLoading: false,
  isTopPrLoading: false,
  isSupportSubmitting: false,
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_MORE_FEED_START: {
      return {
        ...state,
        isNextPageLoading: true,
      };
    }
    case FETCH_MORE_FEED_FULFILLED: {
      return {
        ...state,
        isNextPageLoading: false,
      };
    }
    case FETCH_MORE_FEED_REJECTED: {
      return {
        ...state,
        isNextPageLoading: false,
      };
    }
    case FETCH_FEED_START: {
      return {
        ...state,
        isFeedLoading: true,
      };
    }
    case FETCH_FEED_FULFILLED: {
      return {
        ...state,
        isFeedLoading: false,
      };
    }
    case FETCH_FEED_REJECTED: {
      return {
        ...state,
        isFeedLoading: false,
      };
    }
    case FETCH_PINNED_FEED_START: {
      return {
        ...state,
        isPinnedFeedLoading: true,
      };
    }
    case FETCH_PINNED_FEED_FULFILLED: {
      return {
        ...state,
        isPinnedFeedLoading: false,
      };
    }
    case FETCH_PINNED_FEED_REJECTED: {
      return {
        ...state,
        isPinnedFeedLoading: false,
      };
    }
    case FETCH_FEED_COUNT_START: {
      return {
        ...state,
        isPrCountLoading: true,
      };
    }
    case FETCH_FEED_COUNT_FULFILLED: {
      return {
        ...state,
        isPrCountLoading: false,
      };
    }
    case FETCH_FEED_COUNT_REJECTED: {
      return {
        ...state,
        isPrCountLoading: false,
      };
    }
    case UPLOAD_MEDIA_START: {
      return {
        ...state,
        isMediaLoading: true,
      };
    }
    case UPLOAD_MEDIA_FULFILLED: {
      return {
        ...state,
        isMediaLoading: false,
      };
    }
    case UPLOAD_MEDIA_REJECTED: {
      return {
        ...state,
        isMediaLoading: false,
      };
    }
    case UPLOAD_MEDIA_URL_START: {
      return {
        ...state,
        isMediaLoading: true,
      };
    }
    case UPLOAD_MEDIA_URL_FULFILLED: {
      return {
        ...state,
        isMediaLoading: false,
      };
    }
    case UPLOAD_MEDIA_URL_REJECTED: {
      return {
        ...state,
        isMediaLoading: false,
      };
    }
    case FETCH_FEED_POST_START: {
      return {
        ...state,
        isFeedLoading: true,
      };
    }
    case FETCH_FEED_POST_FULFILLED: {
      return {
        ...state,
        isFeedLoading: false,
      };
    }
    case FETCH_FEED_POST_REJECTED: {
      return {
        ...state,
        isFeedLoading: false,
      };
    }
    case FETCH_EXERCISES_START: {
      return {
        ...state,
        isLoadingExercises: true,
      };
    }
    case FETCH_EXERCISES_FULFILLED: {
      return {
        ...state,
        isLoadingExercises: false,
      };
    }
    case FETCH_EXERCISES_REJECTED: {
      return {
        ...state,
        isLoadingExercises: false,
      };
    }
    case FETCH_TOP_PR_START: {
      return {
        ...state,
        isTopPrLoading: true,
      };
    }
    case EDIT_TOP_PR_START: {
      return {
        ...state,
        isTopPrLoading: true,
      };
    }
    case FETCH_TOP_PR_FULFILLED: {
      return {
        ...state,
        isTopPrLoading: false,
      };
    }
    case EDIT_TOP_PR_FULFILLED: {
      return {
        ...state,
        isTopPrLoading: false,
      };
    }
    case FETCH_TOP_PR_REJECTED: {
      return {
        ...state,
        isTopPrLoading: false,
      };
    }
    case EDIT_TOP_PR_REJECTED: {
      return {
        ...state,
        isTopPrLoading: false,
      };
    }
    case SUBMIT_SUPPORT_START: {
      return {
        ...state,
        isSupportSubmitting: true,
      };
    }
    case SUBMIT_SUPPORT_FULFILLED: {
      return {
        ...state,
        isSupportSubmitting: false,
      };
    }
    case SUBMIT_SUPPORT_REJECTED: {
      return {
        ...state,
        isSupportSubmitting: false,
      };
    }
    default: {
      return {
        ...state,
      };
    }
  }
}
